import { Spin, Form, Row, Col, Input, Switch, message, Divider, Alert } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
  WhatsAppOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
  SendOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FormItem,
  InputItem,
  ErrorItem,
  ButtonItem,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import axios from "axios";

class ContactoConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    formConCambios: false,
    correoEnvioActivo: false,
  };

  componentDidMount() {
    this.consultarConfiguracion();
  }

  consultarConfiguracion = () => {
    this.setState({ loading: true });

    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionContacto",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.data) {
          const config = res.data.data;

          this.formRef.current.setFieldsValue({
            horarioSemana: config.horarioSemana,
            horarioFinSemana: config.horarioFinSemana,
            correoContacto: config.correoContacto,
            telefonoContacto: config.telefonoContacto,
            facebookUrl: config.facebookUrl,
            twitterUrl: config.twitterUrl,
            instagramUrl: config.instagramUrl,
            whatsappUrl: config.whatsappUrl,
            googleMapsUrl: config.googleMapsUrl,
            correoEnvioActivo: config.correoEnvioActivo ?? false,
            correoEnvio: config.correoEnvio ?? "",
            nombreEnvio: config.nombreEnvio ?? "",
          });
          this.setState({ correoEnvioActivo: config.correoEnvioActivo ?? false });
        }
      })
      .catch((err) => {
        console.error("Error cargando config contacto", err);
        message.error("Error al cargar la configuración de contacto");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  onFinish = async (values) => {
    this.setState({ loading: true });

    const payload = {
      empresaId: this.props.empresaId,
      ...values,
    };

    return axios
      .post(
        "configuracionTiendaOnline/actualizarConfiguracionContacto",
        payload,
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuración de contacto");
          this.setState({ formConCambios: false });
          return true;
        } else if (res.data.success === 1) {
          message.error("No se pudo modificar la configuración");
          return false;
        } else {
          message.error("Hubo un error y no se modificó la configuración");
          return false;
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Error al guardar");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  onFinishFailed = (e) => {
    ErrorItem(e);
  };

  tieneCambios = () => {
    return this.state.formConCambios;
  };

  guardarDesdePadre = () => {
    return this.formRef.current
      .validateFields()
      .then((values) => {
        return this.onFinish(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
        return false;
      });
  };

  handleValuesChange = (changedValues, allValues) => {
    if (!this.state.formConCambios) {
      this.setState({ formConCambios: true });
    }
  };

  descartarCambios = () => {
    this.setState({ formConCambios: false });
    this.consultarConfiguracion();
  };

  render() {
    return (
      <>
        <Spin spinning={this.state.loading}>
          <Form
            name="contactoConfiguracion"
            layout="vertical"
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            onValuesChange={this.handleValuesChange}
            ref={this.formRef}
            loading={this.state.loading}
          >
            <Row gutter={24}>
              <Col span={12}>
                <DynamicCardForm
                  title={"Horarios de Atención"}
                  style={{
                    margin: "0 auto 12px auto",
                    maxWidth: "98%",
                  }}
                >
                  <FormItem
                    label="Entre Semana (Lunes - Viernes)"
                    name="horarioSemana"
                    max={100}
                    margin
                    tooltip="Ej: 9:00 AM - 6:00 PM"
                  >
                    <InputItem
                      placeholder="Ej: 9:00 AM - 6:00 PM"
                      prefix={
                        <ClockCircleOutlined
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                    />
                  </FormItem>

                  <FormItem
                    label="Fines de Semana"
                    name="horarioFinSemana"
                    max={100}
                    margin
                    tooltip="Ej: Sábados 10:00 AM - 2:00 PM, Domingos Cerrado"
                  >
                    <InputItem
                      placeholder="Ej: Sábados 10:00 AM - 2:00 PM"
                      prefix={
                        <ClockCircleOutlined
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                    />
                  </FormItem>
                </DynamicCardForm>
                <div style={{ marginTop: 20 }}></div>
                <DynamicCardForm
                  title={"Información de Contacto"}
                  style={{
                    margin: "0 auto 12px auto",
                    maxWidth: "98%",
                  }}
                >
                  <FormItem
                    label="Correo Electrónico"
                    name="correoContacto"
                    max={100}
                    margin
                    tooltip="Correo visible para tus clientes."
                    rules={[
                      { type: "email", message: "Ingresa un correo válido" },
                    ]}
                  >
                    <InputItem
                      placeholder="contacto@miempresa.com"
                      prefix={
                        <MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                      }
                    />
                  </FormItem>

                  <FormItem
                    label="Número de Teléfono"
                    name="telefonoContacto"
                    max={20}
                    margin
                    tooltip="Número visible para llamadas o WhatsApp."
                  >
                    <InputItem
                      placeholder="Ej: 55 1234 5678"
                      prefix={
                        <PhoneOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                      }
                    />
                  </FormItem>
                </DynamicCardForm>
              </Col>

              <Col span={12}>
                <DynamicCardForm
                  title={"Redes Sociales"}
                  style={{
                    margin: "0 auto 12px auto",
                    maxWidth: "98%",
                  }}
                >
                  <FormItem
                    label="Facebook"
                    name="facebookUrl"
                    max={200}
                    margin
                    tooltip="Enlace a tu perfil de Facebook."
                  >
                    <InputItem
                      placeholder="https://facebook.com/tuempresa"
                      prefix={<FacebookOutlined style={{ color: "#1877F2" }} />}
                    />
                  </FormItem>

                  <FormItem
                    label="Twitter (X)"
                    name="twitterUrl"
                    max={200}
                    margin
                    tooltip="Enlace a tu perfil de Twitter."
                  >
                    <InputItem
                      placeholder="https://twitter.com/tuempresa"
                      prefix={<TwitterOutlined style={{ color: "#1DA1F2" }} />}
                    />
                  </FormItem>

                  <FormItem
                    label="Instagram"
                    name="instagramUrl"
                    max={200}
                    margin
                    tooltip="Enlace a tu perfil de Instagram."
                  >
                    <InputItem
                      placeholder="https://instagram.com/tuempresa"
                      prefix={
                        <InstagramOutlined style={{ color: "#E1306C" }} />
                      }
                    />
                  </FormItem>

                  <FormItem
                    label="WhatsApp"
                    name="whatsappUrl"
                    max={200}
                    margin
                    tooltip="Enlace directo a WhatsApp en formato https://wa.me/{lada}{número}. Ej: https://wa.me/5214441234567 (52 = México, 1 = celular, 4441234567 = número sin espacios)."
                    rules={[
                      {
                        pattern: /^https:\/\/wa\.me\/\d{10,15}$/,
                        message:
                          "Formato inválido. Usa https://wa.me/ seguido del número con lada (sólo dígitos).",
                      },
                    ]}
                  >
                    <InputItem
                      placeholder="https://wa.me/5214441234567"
                      prefix={
                        <WhatsAppOutlined style={{ color: "#25D366" }} />
                      }
                    />
                  </FormItem>
                </DynamicCardForm>
                <div style={{ marginTop: 20 }}></div>
                <DynamicCardForm
                  title={"Ubicación"}
                  style={{
                    margin: "0 auto 12px auto",
                    maxWidth: "98%",
                  }}
                >
                  <FormItem
                    label="Google Maps (Enlace o Embed)"
                    name="googleMapsUrl"
                    max={500}
                    margin
                    tooltip="Pega aquí el enlace de Google Maps de tu negocio."
                  >
                    <Input.TextArea
                      rows={3}
                      placeholder="https://maps.google.com/..."
                      style={{ borderRadius: 5 }}
                    />
                  </FormItem>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#888",
                      fontSize: "12px",
                      marginTop: "5px",
                    }}
                  >
                    <EnvironmentOutlined style={{ marginRight: 5 }} />
                    <span>
                      Asegúrate de copiar el enlace de 'Compartir' de Google
                      Maps.
                    </span>
                  </div>
                  <Alert
                    message="¿Cómo obtener el enlace correcto?"
                    description={
                      <>
                        Para obtener los datos correctos debes seguir los
                        siguientes pasos:
                        <br />
                        1. Buscar tu sitio en{" "}
                        <span style={{ fontWeight: 700 }}>Google Maps</span>.
                        <br />
                        2. Clic en{" "}
                        <span style={{ fontWeight: 700 }}>Compartir</span>
                        <br />
                        3.<span style={{ fontWeight: 700 }}>Incorporar</span> un
                        mapa.
                        <br />
                        4. Asegurate que la opción marcada dice{" "}
                        <span style={{ fontWeight: 700 }}>Mediano</span>.
                        <br />
                        5. Encuentra el contenido. Deberías ver algo así{" "}
                        <span style={{ fontWeight: 700 }}>
                          {'<iframe src="https://www.google....."'}
                        </span>
                        .
                        <br />
                        6. Copiar todo el contenido dentro del primer par de
                        comillas{" "}
                        <span style={{ fontWeight: 700 }}>
                          {'"https://www.google..."'}
                        </span>
                        .
                        <br />
                        7.{" "}
                        <span style={{ fontWeight: 700 }}>
                          IMPORTANTE: NO COPIAR{" "}
                          {
                            'width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"'
                          }
                        </span>
                        .
                      </>
                    }
                    type="info"
                    showIcon
                    closable
                    style={{ marginBottom: 20, marginTop: 20 }}
                  />
                </DynamicCardForm>
              </Col>
            </Row>

            <Row gutter={24} style={{ marginTop: 20 }}>
              <Col span={24}>
                <DynamicCardForm
                  title={"Correo de Reenvío"}
                  style={{ margin: "0 auto 12px auto", maxWidth: "99%" }}
                >
                  <Alert
                    message="¿Para qué sirve esto?"
                    description="Cuando un cliente recibe un correo desde tu tienda (confirmación de pedido, etc.), se enviará una copia a la dirección que configures aquí. Activa el interruptor e ingresa el correo y nombre del destinatario."
                    type="info"
                    showIcon
                    style={{ marginBottom: 16 }}
                  />
                  <Row gutter={24} align="middle">
                    <Col xs={24} sm={6} md={4} lg={3}>
                      <FormItem
                        label="Activar reenvío"
                        name="correoEnvioActivo"
                        valuePropName="checked"
                        margin
                      >
                        <Switch
                          onChange={(checked) =>
                            this.setState({ correoEnvioActivo: checked })
                          }
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={18} md={10} lg={10}>
                      <FormItem
                        label="Correo de reenvío"
                        name="correoEnvio"
                        max={100}
                        margin
                        tooltip="Correo al que se reenviarán los emails enviados a clientes."
                        rules={[
                          {
                            type: "email",
                            message: "Ingresa un correo válido",
                          },
                          {
                            required: this.state.correoEnvioActivo,
                            message: "Ingresa el correo de reenvío",
                          },
                        ]}
                      >
                        <InputItem
                          disabled={!this.state.correoEnvioActivo}
                          placeholder="reenvio@miempresa.com"
                          prefix={
                            <SendOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                          }
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={10} lg={11}>
                      <FormItem
                        label="Nombre del destinatario"
                        name="nombreEnvio"
                        max={100}
                        margin
                        tooltip="Nombre que aparecerá como destinatario del correo de reenvío."
                        rules={[
                          {
                            required: this.state.correoEnvioActivo,
                            message: "Ingresa el nombre del destinatario",
                          },
                        ]}
                      >
                        <InputItem
                          disabled={!this.state.correoEnvioActivo}
                          placeholder="Ej: Administración"
                          prefix={
                            <UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                          }
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </DynamicCardForm>
              </Col>
            </Row>

            <Divider style={{ margin: "20px 0" }} />

            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Guardar Configuración
            </ButtonItem>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};
export default connect(mapStateToProps, null, null, { forwardRef: true })(
  ContactoConfiguracion,
);
